var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotificationDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.503,
    height: 22.673
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#757295",
    d: "M9.748 22.673a4.09 4.09 0 01-4.058-3.272H.748a.736.736 0 01-.749-.721v-2.887a.711.711 0 01.333-.6l1.167-.749V7.95a7.747 7.747 0 012.176-5.366A8.354 8.354 0 018.999.044a4.678 4.678 0 01.781-.045 4.849 4.849 0 01.72.045 8.432 8.432 0 012.7.694 5.21 5.21 0 00-.543 1.348 6.9 6.9 0 00-2.9-.632 6.635 6.635 0 00-6.751 6.5v6.88a.718.718 0 01-.333.6l-1.166.747v1.779h16.5v-1.779l-1.167-.747a.72.72 0 01-.333-.6V8.461a5.27 5.27 0 001.249.149c.083 0 .168 0 .252-.006v5.844l1.166.749a.71.71 0 01.333.6v2.887a.737.737 0 01-.75.721h-4.943a4.09 4.09 0 01-4.066 3.268zM7.23 19.401a2.632 2.632 0 002.518 1.829 2.631 2.631 0 002.518-1.829z"
  })));
}

export default SvgNotificationDot;